import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as articleActions from './../Article/articleActions';

import * as config from './../../conf/config';

class EmojiWheel extends Component{

    state = {
        showReactionsMenu: false,
    }

    componentWillMount(){
        if(typeof this.props.articleId !=='undefined'){
            this.props.onEmoReactionRetrieved(this.props.articleId);
        }
            
    }

    toggleReactionsMenu = () => {
        const newValue = !this.state.showReactionsMenu;
        this.setState({ showReactionsMenu: newValue });
    }

    clickReactionHandler =(event) => {
     
        const articleId = this.props.articleId;

        let articleInfo = {};
        const articleData = this.props.articleContent;
        if(articleData.hasOwnProperty('kids_thematic') && articleData.hasOwnProperty('kids_edition')){
        
            articleInfo = { id: articleId,
                            thematic : this.props.articleContent.kids_thematic,
                            edition : this.props.articleContent.kids_edition,
            }
        }

        this.props.onEmoReactionAdded(articleInfo, this.props.user.username, event.target.innerHTML);
    }


    render(){

        let selectedReactionOutput = null;
        if(parseInt(this.props.currentUserReactionId, 10)>0){
            for(let emojiIndex in config.emojiConfig){
                if(config.emojiConfig[emojiIndex].value===parseInt(this.props.currentUserReactionId, 10)){
                    let itemStyle = {
                        'backgroundImage': 'url('+config.emojiConfig[emojiIndex].img+')',
                    }; 
                    selectedReactionOutput = (<span className="selected" style={itemStyle}>{this.props.currentUserReactionId}</span>);
                    break;
                }
            }
        }

        //we order the emoji's array in order to have the good order on display
        const emojiList = config.emojiConfig.sort((a, b) => {
            return b.value - a.value;
        });

        const wheelContent = emojiList.map((itemData, index) => {
            let itemStyle = {
                'backgroundImage': 'url('+itemData.img+')',
            }; 
            return (
                <span key={index} style={itemStyle} className="menu-item" onClick={(e) => this.clickReactionHandler(e)}>{itemData.value}</span>
            );
        });
        
        

        return (
            <div className={(this.state.showReactionsMenu===true && !this.props.closeWheel)?'reactions-container active':'reactions-container'} onClick={this.toggleReactionsMenu} >
                <div className={`main-wheel${selectedReactionOutput===null?' empty':''}`}> 
                    {selectedReactionOutput}
                </div>
                <div className="items-wrapper">
                    {wheelContent}  
                </div>
            </div>
        )
    }

}

const mapStateToProps = state => {
    return {
        user: state.user,
        articleContent : state.article.currentArticle,
        currentUserReactionId : state.article.currentUserArticleReaction,
        emoReactionAdded : state.article.emoReactionAdded,
        userReactionRetrieved : state.article.userReactionRetrieved,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onEmoReactionAdded: (articleId, username, reactionId ) => dispatch(articleActions.addEmoReaction(articleId, username, reactionId )),
        onEmoReactionRetrieved:(articleId) => dispatch(articleActions.getArticleEmoReaction(articleId))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmojiWheel);


// WEBPACK FOOTER //
// ./src/components/EmojiWheel/EmojiWheel.js